<app-main-header [pageTitle]="pageTitle"></app-main-header>

<ion-content id="main-content">
	<ng-container *ngIf="!(isBlockingSync$ | async); else loader">
		<ion-router-outlet
			(activate)="onRouteActivate($event)"
		></ion-router-outlet>
	</ng-container>

	<ng-template #loader>
		<app-loader [message]="'Syncing'"></app-loader>
	</ng-template>
</ion-content>
